var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "top",
      "label-width": "100px",
      size: "mini"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 14
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "架构级别",
      prop: "structure"
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "mini",
      disabled: !!_vm.id
    },
    on: {
      change: _vm.radioChange
    },
    model: {
      value: _vm.form.structure,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "structure", $$v);
      },
      expression: "form.structure"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: 1
    }
  }, [_vm._v("1级架构")]), _c("el-radio-button", {
    attrs: {
      label: 2
    }
  }, [_vm._v("2级部组")]), _c("el-radio-button", {
    attrs: {
      label: 3
    }
  }, [_vm._v("3级部组")]), _c("el-radio-button", {
    attrs: {
      label: 4
    }
  }, [_vm._v("4级部组")]), _c("el-radio-button", {
    attrs: {
      label: 5
    }
  }, [_vm._v("5级部组")])], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 10
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "架构编码",
      prop: "code"
    }
  }, [_c("cpsc-form-select-code-input", {
    attrs: {
      disabled: !!_vm.id,
      "default-selected": _vm.structureCode,
      placeholder: _vm.form.structure === 1 ? "\u8BF7\u8F93\u5165\u56DB\u4F4D\u67B6\u6784\u7F16\u53F7\uFF0C\u4F8B\uFF1A001" : "请输入两位架构标号，例：11",
      maxlength: _vm.form.structure === 1 ? 3 : 2,
      props: _vm.structProps,
      options: _vm.structureList
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.form.code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 14
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "架构名称",
      prop: "l01Name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.l01Name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "l01Name", $$v);
      },
      expression: "form.l01Name"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 10
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "机构简称"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.l01ShortName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "l01ShortName", $$v);
      },
      expression: "form.l01ShortName"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "备注说明"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 4,
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.l01Remark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "l01Remark", $$v);
      },
      expression: "form.l01Remark"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), !_vm.onlyReady ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };